import { Link, useLocation } from 'react-router-dom';

const capitalize = str =>
  str
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');


export default function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean)

  // Hide breadcrumbs on the homepage
  if (location.pathname === '/') {
    return null;
  }

  return (
    <div aria-label="Breadcrumb" className="breadcrumb-container">
      <ol className="breadcrumb-list">
        <li>
        <Link to="/" className="breadcrumb-link text-black no-underline font-bold">Home</Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          return (
            <li key={to} className="breadcrumb-item">
              <span className="breadcrumb-separator">/</span>
              {isLast ? (
                <span className="breadcrumb-current">{capitalize(value)}</span>
              ) : (
                <Link to={to} className="breadcrumb-link">{capitalize(value)}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
